import lhServerClient from ".";

/**
 * 编辑器canvas对象
 */
export class CustomizationCanvas {
    id: number;
    dateCreated: string;
    /**编辑器的宽度 */
    editWidth: number;
    /**编辑器的高度 */
    editHeight: number;
    lastUpdated: string;
    /**图层 */
    layers: CustomizationCanvasLayer[];
}

/**
 * 编辑器图层对象
 */
export interface CustomizationCanvasLayer {
    id: number;
    /**角度 */
    angle: number;
    /**相对与编辑器的高度 */
    height: number;
    /**相对与编辑器的宽度 */
    width: number;
    /**是否可以旋转 */
    canWhirl: boolean;
    /**图片url */
    imageUrl: string;
    /**相对于线框图左边的偏移 */
    left: number;
    /**是否锁定图层 */
    lock: boolean;
    /**原始高度 */
    originalHeight: number;
    /**原始宽度 */
    originalWidth: number;
    /**现有宽度的缩放大小 */
    scale: number;
    /**相对于线框图顶部的偏移 */
    top: number;
    /**图层类型 */
    type: string;
    /**图层的z-index */
    zIndex: number;
    // 图层排序
    index?: number;
    // 字体相关
    /**字体大小 */
    fontSize?: number;
    /**字体内容 */
    fontContent?: string;
    /**字体名称 */
    fontFamily?: string;
    /**字体厚度 */
    fontWeight?: number;
    /**字体颜色 */
    fontColor?: string;
    /**字体方向 */
    layoutOrientation?: string;
}

export interface DiyRule {
    /**查询详情的时候才有此字段 */
    canvas?: CustomizationCanvas;
    canvases?: CustomizationCanvas[];
    canvasId?: number;
    canvasIds?: number[];
    dateCreated: string;
    enable: boolean;
    // 是否已经绑定商品
    hasBinding: boolean;
    id: number;
    index: number;
    lastUpdated: string;
    tagIds: number[];
    thumbUrl: string;
    editable: boolean;
    cloudFileId?: number;
    groupId?: number;
    suitableBottomPanelIds: number[];
}

export interface QueryRulePram {
    pageNo: number;
    pageSize: number;
    enable?: boolean;
    tagIds?: number[];
    groupId?: number | null;
    suitableBottomPanelIds?: number[];
}

export interface QueryRuleResponse {
    content: DiyRule[];
    pageNo: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
}

export function getDiyRule(id: number) {
    return lhServerClient.get<DiyRule>("/diy_rule", { id });
}

export function getDiyRuleList(param: QueryRulePram) {
    return lhServerClient.post<QueryRuleResponse>("/diy_rule/query", param);
}
